import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'src/store';
import { PATH_ONBOARDING } from 'src/constants/spa-routes';
import { OnboardingSide } from 'src/pages/OnboardingPage/OnboardingSide/OnboardingSide';
import { OnboardingHead } from 'src/pages/OnboardingPage/OnboardingHead/OnboardingHead';
import { ProductsType } from 'src/constants/products';
import { updatePlanState } from 'src/store/slices/planSlice';
import { SubscriptionsStatus } from 'src/constants/subscriptions';
import { useGetAccountsQuery } from 'src/services/accountsService';
import { usePHIndentity } from 'src/hooks/usePHIndentity';
import { OnboardingHeadLastStep } from 'src/pages/OnboardingPage/OnboardingHead/OnboardingHeadLastStep';
import { clsx } from 'clsx';

const OnboardingPage = () => {
  const { currentStep } = useAppSelector((s) => s.onboardingSlice);
  const { step } = useParams();
  const IS_LAST_STEP = step === '7';
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { data: accounts } = useGetAccountsQuery();
  usePHIndentity();

  useEffect(() => {
    if (accounts) {
      const isInactivePlan = accounts?.general_plan?.status === SubscriptionsStatus.inactive;
      const isTrialPlan = accounts?.general_plan?.plan?.plan_type === 'trial';

      dispatch(updatePlanState({ isInactivePlan, isTrialPlan }));
    }
  }, [accounts]);

  useEffect(() => {
    if (!step) {
      navigate(`${PATH_ONBOARDING.ROOT}/${currentStep || 0}?type=${ProductsType.customer}`);
    }
  }, []);

  return (
    <div className={`onboarding-page-container w-full h-screen flex flex-row`}>
      {!IS_LAST_STEP && <OnboardingSide />}
      <div
        className={clsx(
          'onboarding-container p-7 overflow-auto flex flex-col gap-5 w-full items-center',
          IS_LAST_STEP && 'min-h-screen',
        )}
      >
        {IS_LAST_STEP ? <OnboardingHeadLastStep /> : <OnboardingHead />}
        <Outlet />
      </div>
    </div>
  );
};

export default OnboardingPage;
